import { FC } from 'react';
import styled from 'styled-components';

const Placeholder = styled.div<{ $width?: string; $height?: string }>`
  position: absolute;
  width: ${({ $width }) => $width || '100%'};
  height: ${({ $height }) => $height || '100%'};
  background: linear-gradient(
    90deg,
    ${({ theme }) => theme.colors.grey[800]} 25%,
    ${({ theme }) => theme.colors.grey[700]} 50%,
    ${({ theme }) => theme.colors.grey[800]} 75%
  );
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  z-index: 0;

  @keyframes shimmer {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
`;

type Props = {
  width?: string;
  height?: string;
  className?: string;
};

const ImagePlaceholder: FC<Props> = ({ width, height, className }) => {
  return <Placeholder $width={width} $height={height} className={className} />;
};

export default ImagePlaceholder;
